import { cva } from "@stubhub/broadway-foundation/css";

export const styles = {
  scrollContainer: cva({
    base: {},
    variants: {
      size: {
        desktop: {},
        mobile: {
          maxWidth: "[calc(100vw - 16px)]",
          minWidth: "[calc(100vw - 16px)]",
        },
      },
    },
    defaultVariants: {
      size: "desktop",
    },
  }),
  container: cva({
    base: {
      display: "flex",
      flexGrow: "1",
      maxWidth: "[1200px]",
      marginInlineStart: "auto",
      marginInlineEnd: "auto",
      width: "full",
    },
    variants: {
      size: {
        desktop: {
          marginBlockStart: "primitives.300",
        },
        mobile: {
          marginBlockStart: "primitives.250",
          minHeight: "[325px]",
        },
      },
    },
    defaultVariants: {
      size: "desktop",
    },
  }),
} as const;
